import Model from "../Model";

export interface TReport3Applicant {
  applicantId: number;
  partyId: string;
  firstName: string;
  lastName: string;
  fatherName: string;
  motherSurname: string;
  submitedReportsNumber: number;
  submitDates: string[];
  submitReason: string;
}

export interface IReport3Applicant extends TReport3Applicant {}

const Report3Applicant = Model(
  (model: TReport3Applicant): IReport3Applicant => {
    const _applicantReport: TReport3Applicant = Object.assign({}, model);

    return {
      get applicantId() {
        return _applicantReport.applicantId;
      },

      get partyId() {
        return _applicantReport.partyId;
      },

      get firstName() {
        return _applicantReport.firstName;
      },

      get lastName() {
        return _applicantReport.lastName;
      },

      get fatherName() {
        return _applicantReport.fatherName;
      },

      get motherSurname() {
        return _applicantReport.motherSurname;
      },

      get submitedReportsNumber() {
        return _applicantReport.submitedReportsNumber;
      },

      get submitDates() {
        return _applicantReport.submitDates;
      },

      get submitReason() {
        return _applicantReport.submitReason;
      }
    };
  }
);

export default Report3Applicant;
